export default {"src":"/_next/static/media/CRM.1921aef2.svg","height":18,"width":18};